import {css} from 'aphrodite';
import React from 'react';

import {styles} from 'processes/settings/ProcessTaskSchemaEditorStyles';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import ErrorMessage from 'ui-library/ErrorMessage';
import {TextFieldType} from 'ui-library/inputs/EditableTextField';
import SettingsField from 'ui-library/SettingsField';
import {MAX_LENGTH_FOR_URL_CHECKING} from 'ui-library/UrlAwareText';

// We use the UrlAwareText component to render task group instructions. So we need to ensure that the task
// group instructions field does not exceed the maximum length that that component can handle.
export const TASK_GROUP_INSTRUCTIONS_CHARACTER_LIMIT = MAX_LENGTH_FOR_URL_CHECKING;

export interface TaskGroupInstructionsFieldProps {
  label: string;
  value: string;
  isBeingCreated: boolean;
  onChange: (updatedInstructions: string) => void;
  error?: string;
  isDisabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function ProcessTaskGroupInstructionsField(
  props: TaskGroupInstructionsFieldProps
): JSX.Element {
  return (
    <div className={css(styles.taskGroupInstructionEditorContainer)}>
      <SettingsField
        label={props.label}
        name={props.label}
        error={props.error}
        value={props.value}
        isBeingCreated={props.isBeingCreated}
        isRequired={false}
        isWritable={Boolean(!props.isDisabled)}
        maxLength={TASK_GROUP_INSTRUCTIONS_CHARACTER_LIMIT}
        onChange={(value: string) => {
          props.onChange(value);
        }}
        type={TextFieldType.TEXTAREA}
        urlAware={true}
        emptyValueAllowed={true}
        textPlaceholder="None"
        dataTestAttrs={props.dataTestAttrs}
        autoSize={true}
      />
      <ErrorMessage error={props.error} />
    </div>
  );
}
